function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useCallback } from 'react';
import { useRefCallback, useSingleton } from '@bydesign-ui/hooks';
import { RangeTime } from '../../../models/date';
import { useSimpleTime } from './useSimpleTime';
export function useRangeTime(options) {
  var value = options.value,
      onChange = options.onChange,
      timeRangDisabled = options.timeRangDisabled,
      locale = options.locale,
      extra = _objectWithoutProperties(options, ["value", "onChange", "timeRangDisabled", "locale"]);

  var onChangeCallback = useRefCallback(onChange);
  var handleChange = useCallback(function (newValue, part) {
    onChangeCallback(part === 'left' ? [newValue, value && value[1] || ''] : [value && value[0] || '', newValue]);
  }, [value]);

  var _ref = timeRangDisabled ? timeRangDisabled('start') : {},
      _ref$disabledHours = _ref.disabledHours,
      startH = _ref$disabledHours === void 0 ? undefined : _ref$disabledHours,
      _ref$disabledMinutes = _ref.disabledMinutes,
      startM = _ref$disabledMinutes === void 0 ? undefined : _ref$disabledMinutes,
      _ref$disabledSeconds = _ref.disabledSeconds,
      startS = _ref$disabledSeconds === void 0 ? undefined : _ref$disabledSeconds;

  var _ref2 = timeRangDisabled ? timeRangDisabled('end') : {},
      _ref2$disabledHours = _ref2.disabledHours,
      endH = _ref2$disabledHours === void 0 ? undefined : _ref2$disabledHours,
      _ref2$disabledMinutes = _ref2.disabledMinutes,
      endM = _ref2$disabledMinutes === void 0 ? undefined : _ref2$disabledMinutes,
      _ref2$disabledSeconds = _ref2.disabledSeconds,
      endS = _ref2$disabledSeconds === void 0 ? undefined : _ref2$disabledSeconds;

  var leftPanel = useSimpleTime(_objectSpread({
    part: 'left',
    locale: locale,
    value: value[0] || '',
    disabledHours: startH,
    disabledMinutes: startM,
    disabledSeconds: startS,
    onChange: function onChange(val) {
      return handleChange(val, 'left');
    }
  }, extra));
  var rightPanel = useSimpleTime(_objectSpread({
    part: 'right',
    locale: locale,
    value: value[1] || '',
    disabledHours: endH,
    disabledMinutes: endM,
    disabledSeconds: endS,
    onChange: function onChange(val) {
      return handleChange(val, 'right');
    }
  }, extra));
  var root = useSingleton(function () {
    return new RangeTime({
      left: leftPanel,
      right: rightPanel
    });
  });
  return {
    root: root,
    leftPanel: leftPanel,
    rightPanel: rightPanel
  };
}